import {useState} from 'react'
import {getModule} from '../services'
import {ModuleModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useOptionService = () => {
  const [loading, setLoading] = useState(false)
  const [module, setModule] = useState<SelectModel[]>([])

  const getModuleData = async (optionsParams: ModuleModel) => {
    setLoading(true)
    try {
      const response = await getModuleService(optionsParams)
      return response.data.data
    } catch (error) {
      console.error('Error fetching option data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getModuleService = async (optionsParams: ModuleModel) => {
    let obj: ModuleModel = {
      ...optionsParams,
    }
    return await getModule(obj, 1)
  }

  const updateOptionList = (mappedSites: {value: string; label: string}[]) => {
    setModule(mappedSites)
  }

  const getModuleList = async (optionsParams: ModuleModel = {}) => {
    try {
      const data = await getModuleData(optionsParams)
      const mappedSites = mapDataSelect(data, 'id', 'nombre')
      updateOptionList(mappedSites)
    } catch (error) {
      console.error('Error fetching option data:', error)
    }
  }

  const handleClear = () => {
    setModule([])
  }

  return {
    loading,
    module,
    handleClear,
    getModuleList,
  }
}
export default useOptionService
